import Grid from "@material-ui/core/Grid";
import {
  Autocomplete,
  autocompleteHelpers,
  CrudForm,
  CrudRoute,
  CrudTabs,
  DatePicker,
  Filter,
  FormApi,
  List,
  ListApi,
  loopback,
  MountEntity,
  useParentChildrenNavigation,
  SimpleFormDialog,
  SimpleDialog,
  crudFormEnums,
} from "elentari";
import { TextField } from "final-form-material-ui";
import moment from "moment";
import React, { useState } from "react";
import { Field } from "react-final-form";
import {
  avalAvaliacaoApi,
  clienteApi,
  indicadorAvalApi,
  indicadorAvalAvaliacaoApi,
} from "../../services/Api";
import SendIcon from "@material-ui/icons/Send";
import { getFcmAfterLoad } from "../Fcm/getFcmAfterLoad";
import { getUTCFormatedDate } from "../../utils/dateParse";

const { loopbackFilters } = loopback;

function AvalAvaliacaoFilter(props) {
  return (
    <Filter
      formatFilters={{ clienteId: (value) => value.id }}
      labels={{ find: "Buscar", clear: "Limpar" }}
    >
      <Grid spacing={24} container>
        <Grid item xs>
          <Field
            label="Cliente"
            loadOptions={loadClientes}
            component={Autocomplete}
            name="clienteId"
          />
        </Grid>
      </Grid>
    </Filter>
  );
}

export function AvalAvaliacaoList(props) {
  const listOptions = {
    defaultOrder: "dataCadastro desc",
    fields: {
      cliente: {
        label: "Cliente",
      },
      dataCadastro: {
        label: "Data",
        format: (date) =>
          date ? moment(getUTCFormatedDate(date)).format("DD/MM/YYYY") : "",
      },
    },
  };

  const getPageDecorator = async ({ getPage }) => {
    const items = await getPage();
    if (!items) return;
    const promises = items.map(async (item) => {
      const response = await clienteApi.getOne(item.clienteId);
      if (response.ok) {
        return {
          ...item,
          cliente: response.data.nome,
          clienteId: undefined,
        };
      }
      return item;
    });
    return Promise.all(promises);
  };

  return (
    <ListApi getPageDecorator={getPageDecorator} api={avalAvaliacaoApi}>
      {({ getPage, getCount, handleDelete }) => (
        <div>
          <AvalAvaliacaoFilter />
          <List
            {...props}
            withPaper
            labelNew="Novo"
            deleteItem={handleDelete}
            onClickEdit={(item) =>
              props.history.push(`/aval-avaliacao/${item.id}`)
            }
            onClickNew={() => props.history.push("/aval-avaliacao/new")}
            getPage={getPage}
            getCount={getCount}
            listOptions={listOptions}
          />
        </div>
      )}
    </ListApi>
  );
}

export function AvalAvaliacaoForm(props) {
  const [statusNotificacao, setStatusNotificacao] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorOnSendMessage, setErrorOnSendMessage] = useState(false);
  const FCMUtils = getFcmAfterLoad();

  const fetchAvalAvaliacao = async (event) => {
    if (props.match.params.id === "new") {
      setStatusNotificacao(false);
      return;
    }
    const response = await avalAvaliacaoApi.getOne(props.match.params.id);
    if (response.ok) setStatusNotificacao(response.data.notificado);
  };

  const validate = (values) => ({
    cliente: values.cliente ? undefined : "Obrigatório",
  });

  const submitDecorator = async ({ data, id, handleSubmit }) => {
    const result = await handleSubmit({
      id,
      data: {
        ...data,
        cliente: undefined,
        clienteId: data.cliente.id,
      },
    });
    return result;
  };

  const getItem = async () => {
    const result = await MountEntity(props, avalAvaliacaoApi.getOne)
      .populate(({ data, id }) => ({
        cliente: clienteApi.getOne(data.clienteId),
      }))
      .clean(["clienteId"])
      .map((data) => ({
        ...data,
        cliente: autocompleteHelpers.toOption("nome")(data.cliente),
        dataCadastro: getUTCFormatedDate(data.dataCadastro),
      }))
      .getItem();
    FCMUtils.getClientFcmById(result.cliente.id);
    return result;
  };

  const enviarNotificacao = async (title, body) => {
    const id = props.match.params.id;
    const response = await avalAvaliacaoApi.notify(id, { title, body });
    if (!response.ok) setErrorOnSendMessage(true);
  };

  const customActions = [
    {
      label: statusNotificacao ? "Notificar novamente" : "Notificar",
      icon: <SendIcon style={{ marginLeft: 10 }} />,
      onClick: () => setDialogOpen(true),
      pristine: crudFormEnums.PRISTINE_BEHAVIOR.DISABLED_WHEN_DIRTY,
    },
  ];

  return (
    <>
      <FormApi
        api={avalAvaliacaoApi}
        submitDecorator={submitDecorator}
        {...props}
      >
        {({ handleSubmit }) => (
          <CrudForm
            withPaper
            validate={validate}
            history={props.history}
            getItem={getItem}
            onSubmit={handleSubmit}
            customActions={props.match.params.id !== "new" ? customActions : []}
          >
            <Grid container direction="column" spacing={16}>
              <Grid item>
                <Grid container spacing={16}>
                  <Grid item xs>
                    <Field
                      label="Cliente"
                      loadOptions={loadClientes}
                      component={Autocomplete}
                      name="cliente"
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Field
                      fullWidth
                      component={DatePicker}
                      label="Data Avaliação"
                      name="dataCadastro"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CrudForm>
        )}
      </FormApi>
      <SimpleFormDialog
        title="Notificar"
        open={dialogOpen}
        buttonLabel="Cancelar"
        primaryAction={(title, body) =>
          enviarNotificacao(title, body).then(fetchAvalAvaliacao)
        }
        primaryActionButtonLabel="Enviar"
        firstFormLabel="Título"
        firstDefaultValue="Avaliação"
        secondFormLabel="Mensagem"
        secondDefaultValue="Sua avaliação está disponível!"
        disabledText={FCMUtils.state}
        handleClose={() => {
          setDialogOpen(false);
          fetchAvalAvaliacao();
        }}
      />
      <SimpleDialog
        title="Atenção"
        message="Ocorreu um erro no envio da mensagem, por favor tente novamente mais tarde."
        open={errorOnSendMessage}
        primaryActionButtonLabel="Ok"
        handleClose={() => setErrorOnSendMessage(null)}
      />
    </>
  );
}

const loadClientes = async (inputValue) => {
  const response = await clienteApi.getList({
    where: {
      nome: loopbackFilters.regexp(inputValue),
    },
    order: "nome asc",
    limit: 40,
  });
  if (response.ok) {
    return response.data.map(autocompleteHelpers.toOption("nome"));
  }
  return [];
};

const loadIndicador = async (inputValue) => {
  const response = await indicadorAvalApi.getTipoExercicio();
  if (response.ok) {
    return response.data.map((tipoExercicio) => {
      return { value: tipoExercicio, label: tipoExercicio, id: tipoExercicio };
    });
  }
  return [];
};

export function IndicadorAvalAvaliacaoForm(props) {
  const validate = (values) => ({
    valor: values.valor ? undefined : "Obrigatório",
    tipoExercicio: values.tipoExercicio ? undefined : "Obrigatório",
  });

  const getItem = async () => {
    return MountEntity(props, indicadorAvalAvaliacaoApi.getOne)
      .map((data) => ({
        ...data,
        tipoExercicio: {
          value: data.tipoExercicio,
          label: data.tipoExercicio,
          id: data.tipoExercicio,
        },
      }))
      .getItem();
  };

  const submitDecorator = async ({ data, id, handleSubmit }) => {
    const result = await handleSubmit({
      id,
      data: {
        ...data,
        tipoExercicio: data.tipoExercicio.value,
        valor: +data.valor,
        avalAvaliacaoId: +props.match.params.id,
      },
    });
    setTimeout(() => props.history.goBack(), 500);
    return result;
  };

  return (
    <FormApi
      submitDecorator={submitDecorator}
      api={indicadorAvalAvaliacaoApi}
      {...props}
    >
      {({ handleSubmit }) => (
        <CrudForm
          withPaper
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container direction="column" spacing={16}>
            <Grid item>
              <Grid container spacing={16}>
                <Grid item xs>
                  <Field
                    label="Indicador"
                    loadOptions={loadIndicador}
                    component={Autocomplete}
                    name="tipoExercicio"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    type="number"
                    fullWidth
                    component={TextField}
                    label="Valor"
                    name="valor"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}

function IndicadorAvalAvaliacaoList(props) {
  const listOptions = {
    defaultOrder: "valor",
    fields: {
      tipoExercicio: {
        label: "Indicador",
      },
      valor: {
        label: "Valor",
      },
      nome: {
        label: "Classificação",
      },
    },
  };

  const getPageDecorator = async () => {
    const items = await indicadorAvalAvaliacaoApi.getList({
      where: { avalAvaliacaoId: props.match.params.id },
    });
    const avalAvaliacaoResponse = await avalAvaliacaoApi.getOne(
      props.match.params.id
    );
    if (!items.data.length) {
      return undefined;
    }
    const promises = items.data.map(async (item) => {
      const response = await indicadorAvalApi.getClientIndicadorResult({
        clienteId: avalAvaliacaoResponse.data.clienteId,
        indicadorAvalAvaliacaoId: item.id,
      });

      if (response.ok && response.data) {
        item.indicador = `${response.data.tipoExercicio}`;
        item.nome = `${response.data.nome}`;
        item.indicadorAvalId = undefined;
        return item;
      }
      item.nome = "Indicador não cadastrado";
      return item;
    });
    return Promise.all(promises);
  };

  return (
    <ListApi
      api={indicadorAvalAvaliacaoApi}
      getPageDecorator={getPageDecorator}
    >
      {({ getPage, getCount, handleDelete }) => (
        <List
          {...props}
          withPaper
          deleteItem={handleDelete}
          labelNew="Novo"
          onClickEdit={(item) =>
            props.history.push(`${props.location.pathname}/${item.id}`)
          }
          onClickNew={props.onClickNew}
          getCount={getCount}
          getPage={getPage}
          listOptions={listOptions}
        />
      )}
    </ListApi>
  );
}

export function AvalAvaliacaoTabs(props) {
  const { current, navigate } = useParentChildrenNavigation(props, {
    mainPath: "aval-avaliacao",
    availableTabs: ["cadastrar-indicador"],
  });
  return (
    <CrudTabs
      {...props}
      mainPath="aval-avaliacao"
      current={current}
      tabs={[
        { value: "", label: "Avaliação" },
        { value: "cadastrar-indicador", label: "Indicadores" },
      ]}
      navigate={navigate}
    >
      <div>
        <CrudRoute render={() => <AvalAvaliacaoForm {...props} />} />
        <CrudRoute
          name="cadastrar-indicador"
          render={(props) => (
            <IndicadorAvalAvaliacaoList
              onClickNew={navigate("newChild")}
              {...props}
            />
          )}
        />
        <CrudRoute
          name="cadastrar-indicador"
          isForm
          render={(props) => <IndicadorAvalAvaliacaoForm {...props} />}
        />
      </div>
    </CrudTabs>
  );
}
